import React from "react";
import {Route} from "react-router-dom";


const module = (shopApp) => {
	const ShoppingCart = shopApp.dynamic(() => import("./ShoppingCart"));

	const url = "/shopping_cart";

	let config = {
		name: "ShoppingCart",
		routes: [
			<Route key={url} exact path={url} component={ShoppingCart}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
